import { state } from '@/state/modules/clientzone/layout/state';
import { mutations } from '@/state/modules/clientzone/layout/mutations';
import { getters } from '@/state/modules/clientzone/layout/getters';
import { actions } from '@/state/modules/clientzone/layout/actions';

const layoutModule = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}

export default layoutModule
